export const SEARCH_START = 'SEARCH_START';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const CLEAR_CREATE_ERROR = 'CLEAR_CREATE_ERROR';
export const CREATE_START = 'CREATE_START';
export const CREATE_SUCCESS = 'CREATE_SUCCESS';
export const CREATE_FAILURE = 'CREATE_FAILURE';

export const CLEAR_ACTIVATE_ERROR = 'CLEAR_ACTIVATE_ERROR';
export const ACTIVATE_START = 'ACTIVATE_START';
export const ACTIVATE_SUCCESS = 'ACTIVATE_SUCCESS';
export const ACTIVATE_FAILURE = 'ACTIVATE_FAILURE';

export const SHOW_START = 'SHOW_START';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const CAPACITY_START = 'CAPACITY_START';
export const CAPACITY_SUCCESS = 'CAPACITY_SUCCESS';
export const CAPACITY_FAILURE = 'CAPACITY_FAILURE';

export const ACTIVE_START = 'ACTIVE_START';
export const ACTIVE_SUCCESS = 'ACTIVE_SUCCESS';
export const ACTIVE_FAILURE = 'ACTIVE_FAILURE';

export const DESTROY_START = 'DESTROY_START';
export const DESTROY_SUCCESS = 'DESTROY_SUCCESS';
export const DESTROY_FAILURE = 'DESTROY_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
